<template>  
  <v-layout class="drawer-container" column >
    <v-toolbar class="header-list white" dense @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');" >
      <div  class="flex-grow-0" style="border:1px solid #ccc;border-bottom: 0px;border-top: 0px;border-left:0px ;">        
        <v-btn v-if="!allMissionVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_SHOW_ALL_DRAWER_MISSION_MAP('');" :title="$t('Pilot.MissionDrawer.ShowAllListedMissionTooltip')" ><v-icon>mdi-eye-off</v-icon></v-btn>  
        <v-btn v-if="allMissionVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_HIDE_ALL_DRAWER_MISSION_MAP('');" :title="$t('Pilot.MissionDrawer.HideAllListedMissionTooltip')" ><v-icon>mdi-eye</v-icon></v-btn>  
      </div>
      <v-menu offset-y  >
        <v-btn slot="activator" class="text-none" flat ><v-icon class="mr-2" v-text="simulatedMissionActive?'mdi-laptop':'mdi-waves'" /> {{simulatedMissionActive?$t('Pilot.MissionDrawer.Simulated'):$t('Pilot.MissionDrawer.AtSea')}} (<v-icon class="mr-1" size="18" v-text="ongoingMissionActive?'mdi-timer-outline':'mdi-archive'" /> <span class="text-lowercase">{{ongoingMissionActive?$t('Pilot.MissionDrawer.OnGoing'):$t('Pilot.MissionDrawer.Old')}}</span>) <v-icon class="ml-2">mdi-chevron-down</v-icon></v-btn>
        <v-list>                
          <v-list-tile :class="{'primary white--text':!simulatedMissionActive && ongoingMissionActive}" @click="$store.myActions.UI_UNACTIVE_SIMULATED_MISSION_VIEW();$store.myActions.UI_ACTIVE_ONGOING_MISSION_VIEW()">             
            <v-list-tile-title><v-icon class="mr-2" :class="{'white--text':!simulatedMissionActive && ongoingMissionActive }">mdi-waves</v-icon> {{$t('Pilot.MissionDrawer.AtSea')}} (<v-icon class="mr-1" size="18" :class="{'white--text':!simulatedMissionActive && ongoingMissionActive }" >mdi-timer-outline</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.OnGoing')}}</span>)</v-list-tile-title>            
          </v-list-tile>
          <v-list-tile :class="{'primary white--text':!simulatedMissionActive && !ongoingMissionActive}" @click="$store.myActions.UI_UNACTIVE_SIMULATED_MISSION_VIEW();showFinishedMission()">             
            <v-list-tile-title ><v-icon class="mr-2" :class="{'white--text':!simulatedMissionActive && !ongoingMissionActive}">mdi-waves</v-icon> {{$t('Pilot.MissionDrawer.AtSea')}} (<v-icon class="mr-1" size="18" :class="{'white--text':!simulatedMissionActive && !ongoingMissionActive}" >mdi-archive</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.Old')}}</span>)</v-list-tile-title>            
          </v-list-tile>
          <v-list-tile :class="{'primary white--text':simulatedMissionActive && ongoingMissionActive}"  @click="$store.myActions.UI_ACTIVE_SIMULATED_MISSION_VIEW();$store.myActions.UI_ACTIVE_ONGOING_MISSION_VIEW()">             
            <v-list-tile-title><v-icon class="mr-2" :class="{'white--text':simulatedMissionActive && ongoingMissionActive}">mdi-laptop</v-icon> {{$t('Pilot.MissionDrawer.Simulated')}} (<v-icon class="mr-1" :class="{'white--text':simulatedMissionActive && ongoingMissionActive}" size="18" >mdi-timer-outline</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.OnGoing')}}</span>)</v-list-tile-title>            
          </v-list-tile>
          <v-list-tile :class="{'primary white--text':simulatedMissionActive && !ongoingMissionActive}" @click="$store.myActions.UI_ACTIVE_SIMULATED_MISSION_VIEW();showFinishedMission()">             
            <v-list-tile-title ><v-icon class="mr-2" :class="{'white--text':simulatedMissionActive && !ongoingMissionActive}">mdi-laptop</v-icon> {{$t('Pilot.MissionDrawer.Simulated')}} (<v-icon class="mr-1" :class="{'white--text':simulatedMissionActive && !ongoingMissionActive}" size="18" >mdi-archive</v-icon> <span class="text-lowercase">{{$t('Pilot.MissionDrawer.Old')}}</span>)</v-list-tile-title>            
          </v-list-tile>
        </v-list>  
      </v-menu>
      <!-- <mission-operator-filter  /> -->
      <!-- <div style="border:1px solid #ccc;border-bottom: 0px;border-top: 0px;" class="flex-grow-1 d-flex">                    
          <v-btn class="mx-0 px-1 mt-1 ml-1 my-0 flex-grow-1" :input-value="!simulatedMissionActive" flat @click.stop.prevent="$store.myActions.UI_UNACTIVE_SIMULATED_MISSION_VIEW" :title="$t('Pilot.MissionDrawer.AtSeaTooltip')" ><v-icon class="mr-1">mdi-waves</v-icon> <div class="pr-2">{{$t('Pilot.MissionDrawer.AtSea')}}</div></v-btn>                    
          <v-btn class="mx-0 px-1 mt-1 mr-1 my-0 flex-grow-1" :input-value="simulatedMissionActive" flat @click.stop.prevent="$store.myActions.UI_ACTIVE_SIMULATED_MISSION_VIEW" :title="$t('Pilot.MissionDrawer.SimulatedTooltip')" ><v-icon class="mr-1">mdi-laptop</v-icon> {{$t('Pilot.MissionDrawer.Simulated')}}</v-btn>          
      </div>      
      <div  class="flex-grow-1 d-flex">                
          <v-btn class="mx-0 px-1 mt-1 ml-1 my-0 flex-grow-1"  :input-value="ongoingMissionActive" flat @click.stop.prevent="$store.myActions.UI_ACTIVE_ONGOING_MISSION_VIEW" :title="$t('Pilot.MissionDrawer.OnGoingTooltip')" ><v-icon class="mr-1">mdi-timer-outline</v-icon> {{$t('Pilot.MissionDrawer.OnGoing')}}</v-btn>                    
          <v-btn class="mx-0 px-1 mt-1 mr-1 my-0 flex-grow-1"  :input-value="!ongoingMissionActive" flat @click.stop.prevent="showFinishedMission()" :title="$t('Pilot.MissionDrawer.OldTooltip')" ><v-icon class="mr-1">mdi-archive</v-icon> {{$t('Pilot.MissionDrawer.Old')}}</v-btn>                        
      </div>   -->
    </v-toolbar>
    <mission-filter v-show="!ongoingMissionActive" class="filter"  />
    <v-progress-linear v-if="(missionsPassedLoading && !ongoingMissionActive) || (missionsOngoingLoading && ongoingMissionActive)" indeterminate class="my-0"></v-progress-linear>    
    <div ref="liste" class="liste" :style="{overflow:drawerMissions.length <= 24?'auto':'none'}">
      <auto-virtual-scroll-list 
        v-if="drawerMissions.length > 24" 
        v-resize="onResize" :totalHeight="height"
        :defaultHeight="36"
        :extra-items="5"
        style="width: 100%;">            
        <mission-line :mission="mission" v-for="mission in drawerMissions" :key="mission.misId" style="" :uiid="buildMissionUIStateId(mission.misId,'global')"/>        
      </auto-virtual-scroll-list>
      <div v-else >
        <mission-line :mission="mission" v-for="mission in drawerMissions" :key="mission.misId" style="" :uiid="buildMissionUIStateId(mission.misId,'global')" />        
      </div>
    </div>
  </v-layout>
</template>
<script>
  import { mapGetters } from 'vuex'
  import MissionLine from '@/components/mission/MissionLine'  
  import MissionFilter from '@/components/mission/MissionFilter'  
  import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter'  
  import MissionFilterIcon from '@/components/mission/MissionFilterIcon'   
  import {buildMissionUIStateId} from '@/models/ui/MissionUiState'  
  export default {
    name: 'MissionList',
    components:{MissionLine,MissionFilter,MissionFilterIcon,MissionOperatorFilter},    
    data() {
      return {        
        height: 100
      }
   },
   computed: {
       ...mapGetters([         
         'drawerMissions',
         'ongoingMissionActive',
         'simulatedMissionActive',
         'missionsOngoingLoading',
         'missionsPassedLoading',
         'missionsPassedLoaded',   
         'allMissionVisibility'      
      ])
    },    
    mounted(){
      this.onResize()
    },
    methods: {
      onResize(){            
        this.height = this.$refs.liste.clientHeight        
      },
      onContextMenu(){
        alert("ok")
      },
      buildMissionUIStateId(missionId,suffixe) {
        return buildMissionUIStateId(missionId,suffixe)
      },
      showFinishedMission(){         
        this.$store.myActions.UI_UNACTIVE_ONGOING_MISSION_VIEW()
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>  
  .header-list{
    flex: 0 0 auto;
  }
  .filter{
    flex: 0 0 auto;    
    height: min-content;
    background-color: #eee;
  }
 .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }
  
</style>

<style>
  .header-list > .v-toolbar__content{
    padding: 0px;
    display: flex;    
  }
  
</style>

<style scoped>
  button.v-btn--active {
    background-color: var(--primary-color);
    color:white;
  }
</style> 
